import getActiveElementRef from '../GetActiveElementRef'
import getFieldType from '../GetFieldType'

/*
* Determines whether arrow navigation should be disabled based on the type of field that
* is currently in focus, whether suggestions are being shown, etc.
* @param {VueComponent} self
* @param {Event} e
* @return Boolean
*/
export function shouldDisableArrowNav (self, e) {                                                     // Determine whether arrow nav should be disabled when focusing on a specific input
  const { activeElement } = document                                                                  //
  const ref = getActiveElementRef(self, activeElement)                                                // --- Get Vue $ref object
  const type = getFieldType(ref)                                                                      // --- With this element's $ref, we can determine the type of field
  switch (type) {                                                                                     //     which is necessary to determine whether and when to enable or disable arrow navigation
    case 'select':                                                                                    // If field type is <el-select>
      if (e.keyCode === 13 && (ref.options && ref.options.length) && ref.hoverIndex >= 0) {
        return false
      }
      return (ref.options && ref.options.length) && ref.hoverIndex >= 0                               // --- If suggestions are available
    case 'autocomplete':                                                                              // If field type is <el-autocomplete>
      if (e.keyCode === 38 && (ref.highlightedIndex < 0)) {                                           // --- If key is uparrow and user has not highlighted any suggestions
        return false                                                                                  //     don't disable arrow nav
      } else if (e.keyCode === 37) {                                                                  // --- If key is left arrow
        return !(activeElement.selectionStart === 0)                                                  //     and cursor is at the beginning of the string, return false (don't disable arrow nav)
      } else if (e.keyCode === 39) {                                                                  // --- If key is right arrow
        return !(activeElement.selectionStart === activeElement.value.length)                         //     and cursor is not at the end of the string, return true (disable arrow nav)
      } else if (e.keyCode === 13) {
        return false
      }
      return (self.suggestions.active && (ref.suggestions && ref.suggestions.length))                 // --- If any suggestions are currently being shown, disable arrow nav
    case 'input':                                                                                     // If field type is <input>
      if (e.keyCode === 37) {                                                                         // --- If key is left arrow...
        return !(activeElement.selectionStart === 0)                                                  //     and cursor is at the beginning of the string, return false (don't disable arrow nav)
      } else if (e.keyCode === 39) {                                                                  // --- If key is right arrow
        return !(activeElement.selectionStart === activeElement.value.length)                         //     and cursor is not at the end of the string, return true (disable arrow nav)
      }                                                                                               //
      return false                                                                                    // --- If key is neither, don't disable arrow nav
    case 'checkbox':                                                                                  // If field type is <el-checkbox>
      return false                                                                                    // --- Don't disable arrow nav
    case 'date':                                                                                      // If field is <el-date-picker>
      ref.hidePicker()                                                                                // --- first, hide the date picker
      return false                                                                                    //     and don't disable arrow nav
    default:
      return false
  }
}

/*
* Hides open suggestion dropdowns when the user navigates to another cell
* @param {VueComponent} self
* @return void
*/
export function hideOpenSuggestionMenus (self) {
  const { activeElement } = document
  const ref = getActiveElementRef(self, activeElement)
  const type = getFieldType(ref)                                                                      // --- With this element's $ref, we can determine the type of field
  switch (type) {                                                                                     //     which is necessary to determine whether and when to enable or disable arrow navigation
    case 'select':                                                                                    // If field type is <el-select>
      ref.visible = false
      break
    case 'autocomplete':                                                                              // If field type is <el-autocomplete>
      ref.close()
      break
    case 'date':                                                                                      // If field is <el-date-picker>
      ref.hidePicker()                                                                                // --- first, hide the date picker
  }
}

/*
* Handles what happens when the tab key is hit
* @param {VueComponent} self
* @return void
*/
export function handleTabKey (self) {
  const { activeElement } = document
  const ref = getActiveElementRef(self, activeElement)
  if (ref && ref.options && ref.options.length > 0 && ref.hoverIndex > -1) {
    ref.selectOption(ref.hoverIndex)
  }
  if (ref && ref.suggestions && ref.suggestions.length > 0 && ref.highlightedIndex > -1) {
    ref.select(ref.suggestions[ref.highlightedIndex])
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/ArrowNavHelper.js